export { default, getCakeClient } from './SplashCakeClient';
